import { forwardRef } from 'react';

import { cn } from '@crehana/compass.ui/v2';

import type { ActionButtonsProps } from './types';

// TODO: talk with the code owner to fix this code so we can enable this rule again
// eslint-disable-next-line react/display-name
const ActionButtons = forwardRef<HTMLDivElement, ActionButtonsProps>(
  ({ isDark, options }, ref) => (
    <div
      ref={ref}
      className={cn(
        'shadow-tooltip rounded-5 absolute w-200 z-7 right-0 overflow-hidden',
        isDark ? 'bg-gray-main-dark-mode' : 'bg-white',
      )}
    >
      {options.map(({ id, label, onClick, className }) => (
        <button
          key={id}
          type="button"
          className={cn(
            'w-full',
            isDark
              ? 'hover:bg-base-light-dark-mode'
              : 'hover:text-primary-main hover:bg-gray-lighter',
          )}
          onClick={onClick}
        >
          <p className={`font-body4 text-left px-16 py-12 ${className}`}>
            {label}
          </p>
        </button>
      ))}
    </div>
  ),
);

export default ActionButtons;
